import { resolveSocialSourceLocation } from './resolveSocialSourceLocation';

/**
 * Appends `source_location` to SAP navigation params so SAPv2 tracking and publish
 * attribution carry through.
 */
export function appendSourceLocationToSapParams(
	params: URLSearchParams,
	metadataSourceLocation: string | null | undefined,
	urlSourceLocation: string | null | undefined,
): void {
	params.set('source_location', resolveSocialSourceLocation(metadataSourceLocation, urlSourceLocation));
}
